export default "__VITE_ASSET__BWIs9_OQ__"